export default __webpack_public_path__ + "static/chronological-age-calculator-banner-c701e0ebb9923ecb6751cf24b68af35d.jpeg";